import React from 'react';
import Fade from 'react-reveal/Fade';
import { Container } from 'react-bootstrap';
import Title from '../Title/Title';
import useLocalize from '../../common/intl/useLocalize';
import { DEFAULT_DELAY, DEFAULT_DURATION } from '../../common/constants';

const Contact = () => {
  const localize = useLocalize();

  const cta = localize('contact-question-text');
  const btn = localize('contact-action-button');

  return (
    <section id="contact">
      <Container>
        <Title title={localize('contact-title')} />
        <Fade bottom duration={DEFAULT_DURATION} delay={DEFAULT_DELAY * 1.5} distance="30px">
          <div className="contact-wrapper">
            <p className="contact-wrapper__text">{cta}</p>
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="cta-btn cta-btn--resume"
              href="https://www.linkedin.com/in/artsiom-marozau/"
            >
              {btn}
            </a>
          </div>
        </Fade>
      </Container>
    </section>
  );
};

export default Contact;
